import axios from "../plugins/axios";
const cancelTokenSource = axios.CancelToken.source();
const state = {
  type: null,
  o_id: null,
  task_list_modal: false,
  form_name: null,
  bank_name: null,
  project_name: null,
  vendor_name: null,
  item_name: null,
  job_name: null,
  user_name: null,
  customer_name: null,
  task_list_loading: false,
  task_items: [],
  refresh_task_list: false,
  item: {},
  display_date: "",
  // estimated_completed_date: "",
  // revised_completion_date:"",
  task_count: "",
  totalTaskDays: 0,
  totalDelayDays: 0,
  totalExtDelayDays: 0,
  totalTask: "",
  completedTask: "",
  loading: false,
  cancelSource: "",
  totalChangeOrderDays:"", 
};
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key];
  },
};
const actions = {
  cancelSearch({ state }) {
    if (state.cancelSource) {
      state.cancelSource.cancel("Start new search, stop active search");
    }
  },

  async getTasks({ commit, getters }, data) {
    commit("setTaskData", { key: "task_list_loading", value: true });
    commit("setTaskData", { key: "loading", value: "accent" });
    commit("setTaskData", { key: "task_items", value: [] });

    actions.cancelSearch({ state }); // Cancel any ongoing requests
    const cancelSource = axios.CancelToken.source(); // Create new cancel token source

    commit("setTaskData", { key: "cancelSource", value: cancelSource });

    let type = getters.getDataByKey("type");
    let o_id = getters.getDataByKey("o_id");
    await axios
      .get("calendar_task/list?type=" + type + "&o_id=" + o_id + "&" + data, {
        cancelToken: cancelSource.token,
      })
      .then(function(res) {
        let data = res.data;
        commit("setTaskData", { key: "task_items", value: data.data.data });
        commit("setTaskData", {
          key: "task_items_count",
          value: data.data.total,
        });
        commit("setTaskData", { key: "task_count", value: data.task_count });
        actions.getTotalTaskDays(commit, getters);
      })
      .then(function() {
        commit("setTaskData", { key: "task_list_loading", value: false });
        commit("setTaskData", { key: "loading", value: false });
      });
  },

  getTotalTaskDays(commit, getters) {
    let type = getters.getDataByKey("type");
    let o_id = getters.getDataByKey("o_id");
    axios
      .get(
        "calendar_task/get_start_end_task_date?o_id=" + o_id + "&type=" + type,
        {
          cancelToken: cancelTokenSource.token,
        }
      )
      .then((response) => {
        if (response.data.status) {
          let data = response.data;
          commit("setTaskData", {
            key: "totalTaskDays",
            value: data.totalTaskDays,
          });
          commit("setTaskData", {
            key: "totalDelayDays",
            value: data.totalDelayDays,
          });
          commit("setTaskData", {
            key: "totalExtDelayDays",
            value: data.totalExtDelayDays,
          });
          commit("setTaskData", {
            key: "totalTask",
            value: data.totalTask,
          });
          commit("setTaskData", {
            key: "completedTask",
            value: data.completedTask,
          });
          commit("setTaskData", {
            key: "totalChangeOrderDays",
            value: data.totalChangeOrderDays,
          });
        }
      })
      .catch(function() {});
  },
};
const mutations = {
  setTaskData(state, data) {
    state[data.key] = data.value;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
